var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('column',{attrs:{"md":4,"lg":6}},[_c('div',{staticClass:"home-sect-image"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":("/static/images/landing/" + _vm.image + ".jpg")}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec840e2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/HomeSectImage.vue
// module id = 353
// module chunks = 8